import { ApplicationState } from 'redux/reducers';
import type { TemporalLocation } from 'ts/types/location.types';

export const locationSelector = (state: ApplicationState) => state.location;
export const temporalLocationSelector = (
  state: ApplicationState,
): TemporalLocation | undefined => locationSelector(state)?.temporal;
